export const FEEDBACK_TONES = [
  { key: 'blue', label: '파랑' },
  { key: 'purple', label: '보라' },
  { key: 'amber', label: '노랑' },
  { key: 'red', label: '빨강' },
  { key: 'green', label: '초록' },
  { key: 'cyan', label: '청록' },
  { key: 'slate', label: '회색' },
];

const TONE_KEYS = new Set(FEEDBACK_TONES.map((tone) => tone.key));

export function normalizeFeedbackToneKey(value, fallback = 'blue') {
  const key = String(value || '').trim().toLowerCase();
  if (TONE_KEYS.has(key)) return key;
  return TONE_KEYS.has(fallback) ? fallback : 'blue';
}

export function inferFeedbackToneKey(name, autoKeep = false) {
  const text = String(name || '').trim();
  if (/취소|반대|안한다|안하기|관심없음|진행의사없음|오지말라|비상식/.test(text)) return 'red';
  if (/고민|상의|컨펌|자금|권한|소량|단골|직원/.test(text)) return 'amber';
  if (autoKeep || /부재|연락|못만남|소화못함|급한일|일생겨/.test(text)) return 'purple';
  if (/아까운|조율|대표아님|외국인|인지/.test(text)) return 'cyan';
  return 'blue';
}

export function getFeedbackToneVars(value, fallback = 'blue') {
  const key = normalizeFeedbackToneKey(value, fallback);
  return {
    key,
    bg: `var(--mm-tone-${key}-bg)`,
    hoverBg: `var(--mm-tone-${key}-hover-bg)`,
    text: `var(--mm-tone-${key}-text)`,
    border: `var(--mm-tone-${key}-border)`,
    solidBg: `var(--mm-tone-${key}-solid-bg)`,
    solidBorder: `var(--mm-tone-${key}-solid-border)`,
    solidText: `var(--mm-tone-${key}-solid-text)`,
  };
}
